<div class="h-100 d-flex align-items-center" clickStopPropagation>
  <iris-dms-download-file-button class="d-flex"
                                 [file]="file()"
                                 data-test="file-grid-actions-button">
  </iris-dms-download-file-button>

  @if (isOfficeEditableDocument()) {
    <iris-dms-edit-office-file-button [disabled]="!hasUpdatePermission()"
                                      [file]="file()"
                                      data-test="file-grid-actions-button-2">
    </iris-dms-edit-office-file-button>
  } @else {
    <iris-dms-file-preview-button class="d-flex"
                                  [file]="file()"
                                  data-test="file-grid-actions-button-3">
    </iris-dms-file-preview-button>
  }
</div>
